import React, { useState } from 'react'
import { Box } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxInput from 'components/custom/AdxInput'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'

const ClaimExpenseRejectModal = ({
    isOpen,
    onClose,
    onSubmit,
    isLoading,
    expenseDescription
}) => {
    const [feedback, setFeedback] = useState('')

    const handleSubmit = () => {
        onSubmit(feedback.trim())
    }

    const handleClose = () => {
        setFeedback('')
        onClose()
    }

    return (
        <AdxFormModal
            title={`Reject Expense?`}
            subtitle={`Are you sure you want to reject this expense: "${expenseDescription}"?`}
            open={isOpen}
            handleClose={handleClose}
            disableAutoFocus
            onClose={handleClose}
        >
            <Box>
                <AdxInput
                    label="Reason for rejection (optional)"
                    multiline
                    minRows={3}
                    sxInput={{ padding: 2 }}
                    charLimit={500}
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder="Please provide a reason for rejecting this expense..."
                />
                <Box my={2} display="flex" alignItems="center" justifyContent="center" columnGap={2}>
                    <AdxButton variant={'ghost'} onClick={handleClose}>
                        Cancel
                    </AdxButton>
                    <AdxButton
                        variant={'contained'}
                        color="error"
                        sx={{
                            width: 200,
                            '&:hover': {
                                backgroundColor: 'error.main',
                            },
                        }}
                        disabled={isLoading}
                        isLoading={isLoading}
                        onClick={handleSubmit}
                    >
                        Reject Expense
                    </AdxButton>
                </Box>
            </Box>
        </AdxFormModal>
    )
}

export default ClaimExpenseRejectModal
